import type {
  StructuredFilterGroupRequest,
  StructuredFilterRequest,
} from "@/components/StructuredSearch";

type RawStructuredFilter = StructuredFilterRequest & { nested_key?: string };

const normalizeStructuredFilterRequest = (filter: RawStructuredFilter): StructuredFilterRequest => {
  const { nested_key: snakeNestedKey, nestedKey, ...rest } = filter;
  const normalizedNestedKey = nestedKey ?? snakeNestedKey;
  return normalizedNestedKey ? { ...rest, nestedKey: normalizedNestedKey } : rest;
};

export const normalizeStructuredFilterGroup = (
  filterGroup: StructuredFilterGroupRequest,
): StructuredFilterGroupRequest => ({
  logic: filterGroup.logic,
  filters: filterGroup.filters.map(filter =>
    "logic" in filter
      ? normalizeStructuredFilterGroup(filter)
      : normalizeStructuredFilterRequest(filter as RawStructuredFilter),
  ),
});
